import ClientComponent from "./ClientComponent";
import {logout} from "../clients/UserClient";
import {Table} from "./Table";
import React, {useEffect, useState} from "react";
import {retrieveHistory, retrieveStatistics} from "../clients/HistoryClient";
import {useNavigate} from "react-router-dom";
import {GameVariants} from "../utils/gameEnums";
import Dropdown from "./DropDown";
import FriendColumn from "./FriendColumn";
import AlreadyFriendSymbol from "./svg/AlreadyFriendSymbol";
import FriendPendingSymbol from "./svg/FriendPendingSymbol";
import AddFriendSymbol from "./svg/AddFriendSymbol";
import {fetchFriendStatus, sendFriendRequest} from "../clients/FriendClient";

const getFriendButton = (friendshipStatus, onClick) => {

    let friendshipSymbol, onSymbolClick, friendText;
    const size = "1.2rem";

    switch (friendshipStatus) {
        case "friends":
            friendshipSymbol = <AlreadyFriendSymbol size={size}/>
            friendText = "Already Friends";
            break;
        case "friendshipPending":
            friendshipSymbol = <FriendPendingSymbol size={size}/>
            friendText = "Friendship Pending";
            break;
        case "notFriends":
            friendshipSymbol = <AddFriendSymbol size={size}/>
            friendText = "Add Friend"
            onSymbolClick = onClick;
            break;
    }

    return <div className="friendship-symbol" onClick={onSymbolClick} style={{cursor: onSymbolClick ? "pointer": "inherit", marginTop: "0.2rem"}}>
        {friendshipSymbol}
        <div className="info-message">{friendText}</div>
    </div>
}

const Profile = ({username, ownProfile}) => {
    const [history, setHistory] = useState(null)
    const [statistics, setStatistics] = useState(null)
    const [gameVariant, setGameVariant] = useState(GameVariants.STANDARD)
    //Will be null if it's our own profile
    const [friendStatus, setFriendStatus] = useState(null)

    const navigate = useNavigate()

    //TODO we should improve error handling on this page
    useEffect(() => {
        if(!ownProfile) {
            fetchFriendStatus(username)
                .then((data) => setFriendStatus(data.friendStatus))
                .catch((error) => console.error(error))
        }
    }, [ownProfile])

    useEffect(() => {
        retrieveHistory(username, 10, gameVariant)
            .then((data) => {
                setHistory(data)
            })
            .catch((error) => console.error(error))

        retrieveStatistics(username, gameVariant)
            .then((data) => setStatistics(data))
            .catch(error => console.error(error))


    }, [gameVariant]);


    const goToAnalysis = (row, username) => {
        const state = {}
        state.initialFen = row.initialFen;
        state.moves = row.moves.trim().split(" ")
        state.playerColor = username === row.user1.username ? row.player1Color : row.player2Color;
        state.opponent = username === row.user1.username ? row.user2 : row.user1;
        state.gameId = row.gameId

        navigate("/analysis", {state: state})
    }

    const mapResult = (result) => {
        let src;
        if (result) {
            src = "/plus_symbol.png"
        } else if (result === false) {
            src = "/negative_symbol.png"
        } else {
            src = "/neutral_symbol.png"
        }

        return <img src={src} alt={"The result of the match"} style={{
            maxHeight: '1.5625rem',
            maxWidth: '1.5625rem', marginLeft: '0.6rem'
        }}/>
    }

    const mapMoves = (moves) => {
        return moves.trim().split(" ").length
    }

    const mapUser = (user) => {
        return user.username;
    }

    const StatRow = (props) => {
        return <div style={{
            marginTop: "-1rem",
            display: "flex",
            width: "90%",
            justifyContent: "space-between",
            fontFamily: "monospace",
            height: "2rem",
            color: "gray",
            marginBottom: "1rem"
        }}>
            <p>{props.text}</p>
            <p>{props.value}</p>
        </div>
    }


    const SummaryStatistic = ({statistic}) => {
        const [collapsed, setCollapsed] = useState(false);

        const toggleCollapse = () => {
            setCollapsed(!collapsed)
        }

        return <div className="board-container"
                    style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <div style={{
                backgroundColor: "var(--primary-blue)",
                fontSize: "1.3rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#fff",
                width: "100%",
                height: "3rem",
                cursor: "pointer"
            }}
            onClick={toggleCollapse}
            >
                <p style={{marginLeft: "0.5rem"}}>{statistic.timeVariant.charAt(0).toUpperCase() + statistic.timeVariant.slice(1)}</p>
                <div style={{display: "flex", flexDirection: "row", alignItems: "center", gap: "0.2rem"}}>
                    <p>{statistic.eloPoints}</p>
                    {collapsed ? <img src={"/arrow_down.png"} alt={"Arrow down"} className="icon-style"/> :
                        <img src={"/arrow_up.png"} alt={"Arrow up"} className="icon-style"/>}
                </div>
            </div>
            {!collapsed && <div style={{marginTop: "0.75rem", width: "100%", display: "flex", flexDirection: "column", alignItems: "center"}}>
            <StatRow text="Games won " value={statistic.gamesWon}/>
            <StatRow text="Games played " value={statistic.gamesPlayed}/>
            <StatRow text="Winrate %" value={Math.round(statistic.winrate * 100)}/>
            </div>}
        </div>
    }

    return (<div style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: '2rem', justifySelf: "center"}}>
        <img
            src="/logo.png"
            alt="Site Logo"
            className="header-logo"
        />
        <div style={{display: "flex", alignItems: "center"}}>
            <h3 style={{marginRight: "0.4rem"}}>{username}</h3>
            {friendStatus && getFriendButton(friendStatus, () => sendFriendRequest(username)
                .then(() => setFriendStatus("friendshipPending")))}
        </div>

        <Dropdown values={Object.values(GameVariants)} label={"Game Variant"} handleUpdate={(value) => setGameVariant(value)}/>
        {ownProfile && <ClientComponent buttonTitle="Logout" sendData={logout} showSuccessMessage={false}
                                        callback={() => navigate(0)}/>}
        <div style={{display: "flex", flexDirection: "row", gap: "2rem", alignItems: "flex-start", maxWidth: "90vw"}}>
            {ownProfile && <FriendColumn/>}
            {history && <Table headers={["user1", "user2", "timeVariant", "result", "moves"]}
                               data={history} onRowClick={(row) => goToAnalysis(row, username)}
                               mappingFunctions={{result: mapResult, moves: mapMoves, user1: mapUser, user2: mapUser}}/>}
            {statistics && <div style={{
                display: "grid",
                gridTemplateColumns: "12rem",
                gap: "2rem",
                marginTop: "1.2rem"
            }}>
                {statistics.map((statistic) => <SummaryStatistic statistic={statistic}/>)}
            </div>}
        </div>
    </div>)
}

export default Profile;